/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React, {PureComponent} from 'react';
import {findDOMNode} from 'react-dom';

import {isSafari} from 'utils/user_agent';

import styles from './styles.module.css';

const scrollBarWidth = 8;

const expandShrinkContainerStyles = {
    left: `-${scrollBarWidth + 1}px`, //8px(scrollbar width) + 1px
    bottom: `-${scrollBarWidth}px`, //8px because of scrollbar width
    right: `-${scrollBarWidth}px`, //8px because of scrollbar width
    top: `-${scrollBarWidth + 1}px`, //8px(scrollbar width) + 1px
};

const shrinkScrollDelta = (2 * scrollBarWidth) + 1;
const expandScrollDelta = shrinkScrollDelta + 10;

export default class ItemMeasurer extends PureComponent {
  _node = null;
  _resizeSensorExpand = React.createRef();
  _resizeSensorShrink = React.createRef();
  _positionScrollbarsRef = null;
  _measureItemAnimFrame = null;

  componentDidMount() {
      this._node = findDOMNode(this);

      // Force sync measure for the initial mount.
      // This is necessary to support the DynamicSizeList layout logic.
      if (isSafari() && this.props.size) {
          this._measureItemAnimFrame = window.requestAnimationFrame(() => {
              this._measureItem(false);
          });
      } else {
          this._measureItem(false);
      }

      if (this.props.size) {
      // Don't wait for positioning scrollbars when we have size
      // This is needed triggering an event for remounting a post
          this.positionScrollBars();
      }
  }

  componentDidUpdate(prevProps) {
      if (
          (prevProps.size === 0 && this.props.size !== 0) ||
      prevProps.size !== this.props.size
      ) {
          this.positionScrollBars();
      }
  }

  positionScrollBars = (height = this.props.size) => {
      //we are position these hiiden div scroll bars to the end so they can emit
      //scroll event when height in the div changes
      //Heavily inspired from https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
      //and https://github.com/wnr/element-resize-detector/blob/master/src/detection-strategy/scroll.js
      //For more info http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/#comment-244
      if (this._positionScrollbarsRef) {
          window.cancelAnimationFrame(this._positionScrollbarsRef);
      }
      this._positionScrollbarsRef = window.requestAnimationFrame(() => {
          this._resizeSensorExpand.current.scrollTop = height + expandScrollDelta;
          this._resizeSensorShrink.current.scrollTop =
        (2 * height) + shrinkScrollDelta;
      });
  };

  componentWillUnmount() {
      if (this._positionScrollbarsRef) {
          window.cancelAnimationFrame(this._positionScrollbarsRef);
      }

      if (this._measureItemAnimFrame) {
          window.cancelAnimationFrame(this._measureItemAnimFrame);
      }

      const {onUnmount, itemId, index} = this.props;
      if (onUnmount) {
          onUnmount(itemId, index);
      }
  }

  scrollingDiv = (event) => {
      if (event.target.offsetHeight !== this.props.size) {
          this._measureItem(event.target.offsetWidth !== this.props.width);
      }
  };

  renderItems = () => {
      const item = this.props.item;

      const expandChildStyle = {
          position: 'absolute',
          left: '0',
          top: '0',
          height: `${this.props.size + expandScrollDelta}px`,
          width: '100%',
      };

      const renderItem = (
          <div style={{position: 'relative', ...this.props.styles}} className={this.props.className}>
              {item}
              <div className={styles.scrollableContainer}>
                  <div dir='ltr' className={styles.scrollableWrapper}>
                      <div className={styles.expandShrinkContainer} style={expandShrinkContainerStyles}>
                          <div
                              className={styles.expandShrink}
                              ref={this._resizeSensorExpand}
                              onScroll={this.scrollingDiv}
                          >
                              <div style={expandChildStyle} />
                          </div>
                          <div
                              className={styles.expandShrink}
                              ref={this._resizeSensorShrink}
                              onScroll={this.scrollingDiv}
                          >
                              <div className={styles.shrinkChild} />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
      return renderItem;
  };

  render() {
      return this.renderItems();
  }

  _measureItem = (forceScrollCorrection) => {
      const {handleNewMeasurements, size: oldSize, itemId} = this.props;

      const node = this._node;

      if (
          node &&
      node.ownerDocument &&
      node.ownerDocument.defaultView &&
      node instanceof node.ownerDocument.defaultView.HTMLElement
      ) {
          const newSize = Math.ceil(node.offsetHeight);

          if (oldSize !== newSize) {
              handleNewMeasurements(itemId, newSize, forceScrollCorrection);
          }
      }
  };
}
